import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum CurrentDrawerOpenType {
    AddObject = "addObject",
    EditObject = "editObject",
    EditRoom = "editRoom",
    BSUObject = "bsuObject",
    Null = "null",
    Stack = "stack",
    Trolley = "trolley",
    Anesthesia = "anesthesia",
    Surgeon = "surgeon",
    Slave = "slave",
    Port = "port",
    Console = "console",
}

export type RightDrawerType = {
    isModelOpen: boolean;
    modelTitle: string;
    type: CurrentDrawerOpenType;
};

const initialState = {
    isModelOpen: false,
    modelTitle: "Add new",
    type: CurrentDrawerOpenType.AddObject,
} as RightDrawerType;

const RightDrawerSlice = createSlice({
    name: "rightDrawer",
    initialState: initialState,
    reducers: {
        toggleDrawer: (state, action: PayloadAction<CurrentDrawerOpenType>) => {
            state.isModelOpen = !state.isModelOpen;
            state.type = action.payload;
        },
        updateDrawerTitle: (state, action: PayloadAction<string>) => {
            state.modelTitle = action.payload;
        },
        updateCurrentDrawerOpenType: (state, action: PayloadAction<CurrentDrawerOpenType>) => {
            state.type = action.payload;
        },
        hideDrawer: (state) => {
            state.isModelOpen = false;
        },
    },
});

export const { toggleDrawer, hideDrawer, updateDrawerTitle, updateCurrentDrawerOpenType } =
    RightDrawerSlice.actions;

export default RightDrawerSlice.reducer;
